angular.module('cfn').directive('cfnPartnerAmazoneMachineSettings', [
  '$rootScope',
  '$log',
  '$dialog',
  '$filter',
  'requiresProductLicensePopupService',
  function(
    $rootScope,
    $log,
    $dialog,
    $filter,
    requiresProductLicensePopupService
  ) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        ctrl: '=',
        dto: '=',
        object: '=',
        details: '='
      },
      templateUrl: require('./amazoneMachineSettingsButton.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;

        scope.amazoneMachineSettingsNonauthorized = $filter(
          'nonauthorizedAction'
        )('booking.partner.amazoneMachineSettings');

        scope.amazoneClick = function() {
          if (scope.amazoneMachineSettingsNonauthorized) {
            requiresProductLicensePopupService.showDialog();
            return;
          }

          var modalInstance = $dialog
            .dialog({
              backdropClick: false,
              resolve: {
                scope: function() {
                  return scope;
                }
              }
            })
            .open(
              require('./amazoneMachineSettingsPopup.html'),
              'amazoneMachineSettingsPopupController'
            )
            .then(function(exitResult) {});
        };
      }
    };
  }
]);

var PartnerAmazone = {};
PartnerAmazone.DisplaySettingsForCalendar = function(id) {
  app.invokeAngular(function($dialog, $http) {
    app.startLoading();
    $http
      .get('/365FarmNet/rest/partner/amazone/getSettingsForCalendar/' + id)
      .then(function(response) {
        app.finishLoading();
        var scope = {};
        scope.directData = response.data;
        var modalInstance = $dialog
          .dialog({
            resolve: {
              scope: function() {
                return scope;
              }
            }
          })
          .open(
            require('./amazoneMachineSettingsPopup.html'),
            'partnerAmazoneMachineSettingsPopupController'
          )
          .then(function(exitResult) {});
      });
  });
};
